import {GET_INFO} from '/redux/action/currentUser.action';
import {getAnalyticsUtilDefaultInstance} from '/util/analytics/analytics.util';

export default () => (next: any) => (action: any) => {
  const {type: actionType, payload = {}} = action;

  return Promise.resolve(next(action)).then(() => {
    if (actionType === GET_INFO) {
      const {
        coach: {
          id,
          certified,
          rank: {description: rankDescription} = {},
          highestAchievedRank: {
            description: highestAchievedRankDescription,
          } = {},
        } = {},
        competency,
      } = payload;

      getAnalyticsUtilDefaultInstance().trackUserProperties({
        coachId: id,
        competencyView: competency,
        currentRank: rankDescription,
        highestAchievedRank: highestAchievedRankDescription || 'not available',
        certificationStatus: certified ? 'certified' : 'not certified',
      });
    }
  });
};
